import { render, staticRenderFns } from "./DoHeader.vue?vue&type=template&id=36a1980c&scoped=true"
import script from "./DoHeader.vue?vue&type=script&lang=js"
export * from "./DoHeader.vue?vue&type=script&lang=js"
import style0 from "./DoHeader.vue?vue&type=style&index=0&id=36a1980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a1980c",
  null
  
)

export default component.exports